// eslint-disable-next-line no-unused-vars
import * as nkc from '../services/combatScreen';
import {
  mulTimeDimensionMulIndexMulValueType,
  mulTimeDimensionMulIndexMulValue,
} from '@/utils/reportResponseUtil';

function sortArr(arr, prop, type) {
  arr.sort(function (a, b) {
    return type === 1 ? b[prop] - a[prop] : a[prop] - b[prop];
  });
}

// function random(max) {
//   return Math.random() * max;
// }

const maxData = (num = 0) => {
  const firstNum = Number(String(num).substr(0, 1));
  const length = String(num).length;
  return (firstNum + 1) * Math.pow(10, length - 1);
};

export default {
  namespace: 'combatScreen',

  state: {},

  effects: {
    //查询门店销售排行
    *getQueryStoreSalesRanking({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getGlobalReport, value);
      const da = mulTimeDimensionMulIndexMulValueType(response.data);
      const STORE_SALES_PAIRS = da.ALL.STORE_SALES_PAIRS;
      const STORE_SALES_AMOUNT = da.ALL.STORE_SALES_AMOUNT;
      let initData = STORE_SALES_PAIRS.map((item) => {
        const a = STORE_SALES_AMOUNT.find((d) => d.LABEL === item.LABEL);
        return { ...item, ...a };
      });
      sortArr(initData, 'STORE_SALES_AMOUNT', 1);
      yield put({
        type: 'save',
        payload: {
          queryStoreSalesRanking: initData.slice(0, 5),
        },
      });
    },
    //查询电商销售排行
    *getQueryECSalesRanking({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryECSalesRanking, value);
      const da = mulTimeDimensionMulIndexMulValueType(response.data);
      const EC_SALES_PAIRS = da.ALL.EC_SALES_PAIRS;
      const EC_SALES_AMOUNT = da.ALL.EC_SALES_AMOUNT;
      let initData = EC_SALES_PAIRS.map((item) => {
        const a = EC_SALES_AMOUNT.find((d) => d.LABEL === item.LABEL);
        return { ...item, ...a };
      });
      sortArr(initData, 'EC_SALES_AMOUNT', 1);
      yield put({
        type: 'save',
        payload: {
          queryECSalesRanking: initData.slice(0, 5),
        },
      });
    },
    //查询消费者性别分布接口
    *getQueryConsumerGenderDistribution({ payload: { value } }, { call, put }) {
      const response = yield call(
        nkc.getQueryConsumerGenderDistribution,
        value,
      );
      const da = mulTimeDimensionMulIndexMulValue(response.data);

      const initData = da.ALL.GL_CONSUMER_GENDER_DISTRIBUTION;
      let initDataIn = [];
      let initDataOut = [];
      for (let v of initData) {
        if (v.LABEL === '女性') {
          initDataIn.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#CB5F86' },
          });
          initDataOut.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#FE84A0' },
          });
        } else if (v.LABEL === '男性') {
          initDataIn.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#22B0C3' },
          });
          initDataOut.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#44D1E2' },
          });
        } else {
          initDataIn.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#616161' },
          });
          initDataOut.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#47494F' },
          });
        }
      }
      yield put({
        type: 'save',
        payload: {
          queryConsumerGenderDistribution: [initDataIn, initDataOut],
        },
      });
    },
    //查询消费者年龄分布接口
    *getQueryAgeReport({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryAgeReport, value);
      const da = mulTimeDimensionMulIndexMulValue(response.data);
      const initData = da.ALL.GL_CONSUMER_AGE_DISTRIBUTION;
      const d = [];
      for (let v of initData) {
        if (v.LABEL === '10~19') {
          d.push({
            name: v.LABEL,
            value: v.VALUE,
            sort: 0,
            itemStyle: {
              color: '#006385',
            },
          });
        } else if (v.LABEL === '20~29') {
          d.push({
            name: v.LABEL,
            value: v.VALUE,
            sort: 1,
            itemStyle: {
              color: '#AADDF1',
            },
          });
        } else if (v.LABEL === '30~39') {
          d.push({
            name: v.LABEL,
            value: v.VALUE,
            sort: 2,
            itemStyle: {
              color: '#1EAEE3',
            },
          });
        } else if (v.LABEL === '40~49') {
          d.push({
            name: v.LABEL,
            value: v.VALUE,
            sort: 3,
            itemStyle: {
              color: '#006385',
            },
          });
        } else if (v.LABEL === '50~59') {
          d.push({
            name: v.LABEL,
            value: v.VALUE,
            sort: 4,
            itemStyle: {
              color: '#AADDF1',
            },
          });
        } else if (v.LABEL === '60及以上') {
          d.push({
            name: '>=60',
            value: v.VALUE,
            sort: 5,
            itemStyle: {
              color: '#1EAEE3',
            },
          });
        }
      }
      sortArr(d, 'sort', -1);
      yield put({
        type: 'save',
        payload: {
          queryAgeReport: d,
        },
      });
    },
    //查询消费者支付方式偏好接口
    *getQueryConsumerPayPreference({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryConsumerPayPreference, value);
      const da = mulTimeDimensionMulIndexMulValue(response.data);
      const initData = da.ALL.GL_CONSUMER_PAY_PREFERENCE;
      const d = initData.map((item) => ({
        name: item.LABEL,
        value: item.VALUE,
      }));
      yield put({
        type: 'save',
        payload: {
          queryConsumerPayPreference: d,
        },
      });
    },
    //查询来源分布报表
    *getQueryChannelReport({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryChannelReport, value);
      const da = mulTimeDimensionMulIndexMulValue(response.data);
      const initData = da.ALL.GL_CONSUMER_CHANNEL_DISTRIBUTION;
      const d = initData.map((item) => ({
        name: item.LABEL,
        value: item.VALUE,
      }));
      yield put({
        type: 'save',
        payload: {
          queryChannelReport: d,
        },
      });
    },
    //查询消费者渠道平台偏好接口
    *getQueryConsumerChannelPreference({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryConsumerChannelPreference, value);
      const da = mulTimeDimensionMulIndexMulValue(response.data);
      const initData = da.ALL.GL_CONSUMER_CHANNEL_PREFERENCE;
      const d = initData.map((item) => ({
        name: item.LABEL,
        value: item.VALUE,
      }));
      const queryConsumerChannelPreferenceAll = d.reduce(function (
        total,
        currentValue,
      ) {
        return total + Number(currentValue.value);
      },
      0);
      yield put({
        type: 'save',
        payload: {
          queryConsumerChannelPreference: d,
          queryConsumerChannelPreferenceAll,
        },
      });
    },
    //查询消费者款式偏好接口
    *getQueryConsumerStylePreference({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryConsumerStylePreference, value);
      const da = mulTimeDimensionMulIndexMulValue(response.data);
      const initData = da.ALL.GL_CONSUMER_STYLE_PREFERENCE;
      const d = initData.map((item) => ({
        name: item.LABEL,
        value: item.VALUE,
      }));
      const queryConsumerStylePreferenceAll = d.reduce(function (
        total,
        currentValue,
      ) {
        return total + Number(currentValue.value);
      },
      0);
      yield put({
        type: 'save',
        payload: {
          queryConsumerStylePreference: d,
          queryConsumerStylePreferenceAll,
        },
      });
    },
    //查询粉丝累计关注人数
    *getQueryTotalConcerns({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryTotalConcerns, value);
      const da = mulTimeDimensionMulIndexMulValue(response.data);
      const initData = da.ALL.GL_TOTAL_CONCERNS;
      const queryTotalConcerns = initData.find((item) => {
        return item.LABEL === 'total_concerns';
      }).VALUE;
      const querySubscribeConcerns = initData.find((item) => {
        return item.LABEL === 'subscribe_concerns';
      }).VALUE;
      yield put({
        type: 'save',
        payload: {
          queryTotalConcerns,
          querySubscribeConcerns,
        },
      });
    },
    //查询粉丝终端分布
    *getQueryFansTerminalDistribution({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryFansTerminalDistribution, value);
      const da = mulTimeDimensionMulIndexMulValue(response.data);
      const initData = da.ALL.GL_FANS_TERMINAL_DISTRIBUTION;
      const d = initData.map((item) => ({
        name: item.LABEL,
        value: item.VALUE,
      }));

      yield put({
        type: 'save',
        payload: {
          queryFansTerminalDistribution: d,
        },
      });
    },
    //查询消费者性别分布接口
    *getQueryFansGenderDistribution({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryFansGenderDistribution, value);
      const da = mulTimeDimensionMulIndexMulValue(response.data);

      const initData = da.ALL.GL_FANS_GENDER_DISTRIBUTION;
      let initDataIn = [];
      let initDataOut = [];
      for (let v of initData) {
        if (v.LABEL === '女性') {
          initDataIn.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#CB5F86' },
          });
          initDataOut.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#FE84A0' },
          });
        } else if (v.LABEL === '男性') {
          initDataIn.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#22B0C3' },
          });
          initDataOut.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#44D1E2' },
          });
        } else {
          initDataIn.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#616161' },
          });
          initDataOut.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#47494F' },
          });
        }
      }
      yield put({
        type: 'save',
        payload: {
          queryFansGenderDistribution: [initDataIn, initDataOut],
        },
      });
    },
    //查询粉丝增长来源
    *getQueryFansGrowthSource({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryFansGrowthSource, value);
      const da = mulTimeDimensionMulIndexMulValue(response.data);
      const initData = da.ALL.GL_FANS_GROWTH_SOURCE;
      const d = initData.map((item) => ({
        name: item.LABEL,
        value: item.VALUE,
      }));
      yield put({
        type: 'save',
        payload: {
          queryFansGrowthSource: d,
        },
      });
    },
    //查询近一个月关注量
    *getQueryFansAttentionRecentMonth({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryFansAttentionRecentMonth, value);
      const da = mulTimeDimensionMulIndexMulValue(response.data);
      const initData = da.ALL.GL_FANS_ATTENTION_RECENT_MONTH;
      const d = initData.map((item) => ({
        name: item.LABEL,
        value: item.VALUE,
      }));
      yield put({
        type: 'save',
        payload: {
          queryFansAttentionRecentMonth: d,
        },
      });
    },
    //查询会员总数
    *getQueryGlobalAllMember({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryGlobalAllMember, value);
      const da = mulTimeDimensionMulIndexMulValue(response.data);
      const initData = da.ALL.GL_ALL_MEMBER_UGC;
      let initDataIn = [];
      let initDataOut = [];
      for (let v of initData) {
        if (v.LABEL === '复购会员') {
          initDataIn.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#21AEC1' },
          });
          initDataOut.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#46D1E1' },
          });
        } else if (v.LABEL === '首购会员') {
          initDataIn.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#CCCCCC' },
          });
          initDataOut.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#ffffff' },
          });
        } else {
          initDataIn.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#4662E1' },
          });
          initDataOut.push({
            name: v.LABEL,
            value: v.VALUE,
            itemStyle: { color: '#3FA4FF' },
          });
        }
      }
      yield put({
        type: 'save',
        payload: {
          queryGlobalAllMember: [initDataIn, initDataOut],
        },
      });
    },
    //查询会员购买次数
    *getQueryMemberPurchasesTimes({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryMemberPurchasesTimes, value);
      const da = mulTimeDimensionMulIndexMulValue(response.data);
      const initData = da.ALL.GL_MEMBER_PURCHASES_TIMES;
      const d = [];
      for (let v of initData) {
        if (v.LABEL === '1次') {
          d.push({
            name: v.LABEL,
            value: v.VALUE,
            sort: 0,
            itemStyle: {
              color: '#006385',
            },
          });
        } else if (v.LABEL === '2次') {
          d.push({
            name: v.LABEL,
            value: v.VALUE,
            sort: 1,
            itemStyle: {
              color: '#AADDF1',
            },
          });
        } else if (v.LABEL === '3次') {
          d.push({
            name: v.LABEL,
            value: v.VALUE,
            sort: 2,
            itemStyle: {
              color: '#1EAEE3',
            },
          });
        } else if (v.LABEL === '4次') {
          d.push({
            name: v.LABEL,
            value: v.VALUE,
            sort: 3,
            itemStyle: {
              color: '#006385',
            },
          });
        } else if (v.LABEL === '5次及以上') {
          d.push({
            name: '>=5次',
            value: v.VALUE,
            sort: 4,
            itemStyle: {
              color: '#AADDF1',
            },
          });
        } else {
          d.push({
            value: v.VALUE,
            sort: 5,
            itemStyle: {
              color: '#1EAEE3',
            },
          });
        }
      }
      sortArr(d, 'sort', -1);
      yield put({
        type: 'save',
        payload: {
          queryMemberPurchasesTimes: d,
        },
      });
    },
    //查询会员等级分布
    *getQueryMemberLevelDistribution({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryMemberLevelDistribution, value);
      const da = mulTimeDimensionMulIndexMulValue(response.data);
      const initData = da.ALL.GL_MEMBER_LEVEL_DISTRIBUTION;
      const d = initData.map((item) => ({
        name: item.LABEL,
        value: item.VALUE,
      }));
      yield put({
        type: 'save',
        payload: {
          queryMemberLevelDistribution: d,
        },
      });
    },
    //查询会员市场购买次数
    *getQueryMarketPurchasesTimes({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryMarketPurchasesTimes, value);
      const da = mulTimeDimensionMulIndexMulValue(response.data);
      const allData = da.ALL;
      for (let v in allData) {
        sortArr(allData[v], 'SORT');
      }
      const one =
        allData.ONE_TIMES && allData.ONE_TIMES.length > 0
          ? allData.ONE_TIMES.map((item) => ({
              name: item.LABEL,
              value: item.VALUE,
            }))
          : [];
      const two =
        allData.TWO_TIMES && allData.TWO_TIMES.length > 0
          ? allData.TWO_TIMES.map((item) => ({
              name: item.LABEL,
              value: item.VALUE,
            }))
          : [];
      const three =
        allData.THREE_TIMES && allData.THREE_TIMES.length > 0
          ? allData.THREE_TIMES.map((item) => ({
              name: item.LABEL,
              value: item.VALUE,
            }))
          : [];
      const four =
        allData.FOUR_TIMES && allData.FOUR_TIMES.length > 0
          ? allData.FOUR_TIMES.map((item) => ({
              name: item.LABEL,
              value: item.VALUE,
            }))
          : [];
      console.log('four', four);
      const five =
        allData.FIVE_PLUS_TIMES && allData.FIVE_PLUS_TIMES.length > 0
          ? allData.FIVE_PLUS_TIMES.map((item) => ({
              name: item.LABEL,
              value: item.VALUE,
            }))
          : [];
      const sAllData = [one, two, three, four, five];
      const xData =
        sAllData[0].length > 0 ? sAllData[0].map((item) => item.name) : [];
      yield put({
        type: 'save',
        payload: {
          queryMarketPurchasesTimes: sAllData,
          queryMarketPurchasesTimesXData: xData,
        },
      });
    },
    //查询市场会员活跃度占比
    *getQueryMarketMemberActivity({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryMarketMemberActivity, value);
      const da = mulTimeDimensionMulIndexMulValue(response.data);
      const allData = da.ALL;
      for (let v in allData) {
        sortArr(allData[v], 'SORT');
      }
      //活跃
      const one =
        allData.MARKET_ACTIVE_MEMBER_UGC && allData.MARKET_ACTIVE_MEMBER_UGC.length > 0
          ? allData.MARKET_ACTIVE_MEMBER_UGC.map((item) => ({
              name: item.LABEL,
              value: item.VALUE,
            }))
          : [];
      //非活跃
      const two =
        allData.MARKET_INACTIVE_MEMBER_UGC &&
        allData.MARKET_INACTIVE_MEMBER_UGC.length > 0
          ? allData.MARKET_INACTIVE_MEMBER_UGC.map((item) => ({
              name: item.LABEL,
              value: item.VALUE,
            }))
          : [];
      //沉寂
      const three =
        allData.MARKET_DOMAIN_MEMBER && allData.MARKET_DOMAIN_MEMBER.length > 0
          ? allData.MARKET_DOMAIN_MEMBER.map((item) => ({
              name: item.LABEL,
              value: item.VALUE,
            }))
          : [];

      const sAllData = [one, two, three];
      const xData =
        sAllData[0].length > 0 ? sAllData[0].map((item) => item.name) : [];
      // const d = initData.map(item=>({ name: item.LABEL, value: item.VALUE }));
      yield put({
        type: 'save',
        payload: {
          queryMarketMemberActivityTimes: sAllData,
          queryMarketMemberActivityXData: xData,
        },
      });
    },
    //查询全国会员数和门店数及系列品种数
    *getQueryMiddle({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryMiddle, value);
      const queryMiddle = response.data;
      yield put({
        type: 'save',
        payload: {
          queryMiddle,
        },
      });
    },
    //查询实时销售双数和销量总额
    *getQuerySalesTotal({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQuerySalesTotal, value);
      const querySalesTotal = response.data;
      yield put({
        type: 'save',
        payload: {
          querySalesTotal,
        },
      });
    },
    //查询Top10城市排名
    *getQueryCityTop({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryCityTop, value);
      const queryCityTop = response.data;
      sortArr(queryCityTop, 'amountPaid', 1);
      const topTen = queryCityTop.slice(0, 10);
      const queryCityTopTotal = queryCityTop.reduce(function (
        total,
        currentValue,
      ) {
        return total + Number(currentValue.amountPaid);
      },
      0);
      yield put({
        type: 'save',
        payload: {
          queryCityTop,
          topTen,
          queryCityTopTotal,
        },
      });
    },
    //查询Top10城市粉丝排名
    *getQueryCityFansTop({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryCityFansTop, value);
      const initData = mulTimeDimensionMulIndexMulValueType(response.data).ALL
        .GL_FANS_PROVINCE_DISTRIBUTION;
      sortArr(initData, 'VALUE', 1);
      const fansCityData = initData.map((item) => ({
        name: item.LABEL,
        value: item.VALUE,
      }));
      yield put({
        type: 'save',
        payload: {
          fansCityData,
        },
      });
    },
    //查询门店鞋类销售排行
    *getQueryStoreStyleSalesRanking({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryStoreStyleSalesRanking, value);
      const da = mulTimeDimensionMulIndexMulValueType(response.data);
      const STORE_SALES_AMOUNT = da.ALL.STORE_SALES_AMOUNT;
      const STORE_SALES_PAIRS = da.ALL.STORE_SALES_PAIRS;
      let initData = STORE_SALES_PAIRS.map((item) => {
        const a = STORE_SALES_AMOUNT.find((d) => d.LABEL === item.LABEL);
        return { ...item, ...a };
      });
      sortArr(initData, 'STORE_SALES_AMOUNT', 1);
      yield put({
        type: 'save',
        payload: {
          queryStoreStyleSalesRanking: initData.slice(0, 5),
        },
      });
    },
    //查询电商鞋类销售排行
    *getQueryECStyleSalesRanking({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryECStyleSalesRanking, value);
      const da = mulTimeDimensionMulIndexMulValueType(response.data);
      const EC_SALES_AMOUNT = da.ALL.EC_SALES_AMOUNT;
      const EC_SALES_PAIRS = da.ALL.EC_SALES_PAIRS;
      let initData = EC_SALES_PAIRS.map((item) => {
        const a = EC_SALES_AMOUNT.find((d) => d.LABEL === item.LABEL);
        return { ...item, ...a };
      });
      sortArr(initData, 'EC_SALES_AMOUNT', 1);
      yield put({
        type: 'save',
        payload: {
          queryECStyleSalesRanking: initData.slice(0, 5),
        },
      });
    },
    //查询最受欢迎商品
    *getQueryPopularProducts({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryPopularProducts, value);
      const da = mulTimeDimensionMulIndexMulValue(response.data);
      const initData = da.ALL.GL_POPULAR_PRODUCTS;

      // const d = initData.map(item=>({ name: item.LABEL, value: item.VALUE }));
      const d = initData.map((item) => ({
        name: item.LABEL,
        value: item.VALUE,
      }));
      yield put({
        type: 'save',
        payload: {
          queryPopularProducts: d,
        },
      });
    },
    //查询月销售趋势
    *getQueryMonthlySalesTrend({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryMonthlySalesTrend, value);
      const da = mulTimeDimensionMulIndexMulValue(response.data);
      const ONLINE_SALES = da.ALL.ONLINE_SALES; //线上
      const OFFLINE_SALES = da.ALL.OFFLINE_SALES; //线下
      sortArr(ONLINE_SALES, 'SORT');
      sortArr(OFFLINE_SALES, 'SORT');
      const INIT_ONLINE_SALES = ONLINE_SALES.map((item) => ({
        name: item.LABEL,
        value: item.VALUE,
      }));
      const INIT_ONLINE_SALES_SORT = [...INIT_ONLINE_SALES].sort((a, b) => {
        return b.value - a.value;
      });
      const queryMonthlySalesTrendOneMax = maxData(
        parseInt(INIT_ONLINE_SALES_SORT[0].value, 10),
      );
      const INIT_OFFLINE_SALES = OFFLINE_SALES.map((item) => ({
        name: item.LABEL,
        value: item.VALUE,
      }));
      const INIT_OFFLINE_SALES_SORT = [...INIT_OFFLINE_SALES].sort((a, b) => {
        return b.value - a.value;
      });
      const queryMonthlySalesTrendTwoMax = maxData(
        parseInt(INIT_OFFLINE_SALES_SORT[0].value, 10),
      );
      yield put({
        type: 'save',
        payload: {
          queryMonthlySalesTrend: [INIT_ONLINE_SALES, INIT_OFFLINE_SALES],
          queryMonthlySalesTrendOneMax,
          queryMonthlySalesTrendTwoMax,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {},
};
